/**
 * usePwaManifest — swap the PWA manifest + apple-mobile-web-app-title at runtime
 * based on the current route, so Safari "Add to Home Screen" picks up the right
 * app name (e.g. "GOW Admin" on /admin, "GOW Field" on /field).
 *
 * Usage: call inside the top-level component of each entry route.
 *   usePwaManifest({ manifest: "/manifest-admin.webmanifest", title: "GOW Admin" });
 */
import { useEffect } from "react";

export default function usePwaManifest({ manifest, title }) {
  useEffect(() => {
    if (!manifest && !title) return;

    let manifestLink = document.querySelector('link[rel="manifest"]');
    const originalManifestHref = manifestLink ? manifestLink.getAttribute("href") : null;
    if (manifest) {
      if (!manifestLink) {
        manifestLink = document.createElement("link");
        manifestLink.setAttribute("rel", "manifest");
        document.head.appendChild(manifestLink);
      }
      manifestLink.setAttribute("href", manifest);
    }

    const appleTitleMeta = document.querySelector('meta[name="apple-mobile-web-app-title"]');
    const originalAppleTitle = appleTitleMeta ? appleTitleMeta.getAttribute("content") : null;
    if (title && appleTitleMeta) {
      appleTitleMeta.setAttribute("content", title);
    } else if (title) {
      const m = document.createElement("meta");
      m.setAttribute("name", "apple-mobile-web-app-title");
      m.setAttribute("content", title);
      document.head.appendChild(m);
    }

    return () => {
      // Restore original values if the user navigates away (e.g., from /admin to /)
      if (manifest && manifestLink && originalManifestHref) {
        manifestLink.setAttribute("href", originalManifestHref);
      }
      if (title && appleTitleMeta && originalAppleTitle != null) {
        appleTitleMeta.setAttribute("content", originalAppleTitle);
      }
    };
  }, [manifest, title]);
}
